import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSessionStore } from '../store/sessionStore';
import { SYSTEM_LOGO_URL } from '../brand/systemLogo';

export function buildCasdoorAuthorizeUrl(from: string): string {
  const next = new URL('/oauth/casdoor/callback', window.location.origin);
  if (from && from !== '/') {
    next.searchParams.set('from', from);
  }
  return `/api/v1/auth/login?next=${encodeURIComponent(next.toString())}`;
}

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const status = useSessionStore((s) => s.status);
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  useEffect(() => {
    if (status === 'authenticated') {
      navigate('/', { replace: true });
    }
  }, [navigate, status]);

  return (
    <div className="login-wallpaper">
      <div className="login-card" aria-label="login-sso">
        <div className="brand">
          <img src={SYSTEM_LOGO_URL} alt="Blade OS" className="logo" />
          <h1>Blade OS</h1>
          <p>统一桌面入口</p>
        </div>
        <a
          data-testid="oauth-casdoor"
          href={buildCasdoorAuthorizeUrl(from)}
          className="btn primary"
          style={{ textAlign: 'center' }}
        >
          使用 Casdoor 登录
        </a>
      </div>
      <footer className="login-footer">© Blade OS</footer>
    </div>
  );
}
